<template>
	<div class="login-container">
		<el-form class="login-form" autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm"
			label-position="left">
			<div style="display: flex;justify-content: center;">
				<img @click="changeimg()" :src="imgsrc"
						style="width: 15%;height: auto;left: -35px;position: relative;">
			</div>
			<div class="title-container">
				<h3 class="title"><img @click="changeway()" src="../assets/img/logoNew.png"
						style="width: 80%;height: auto;"></h3>
				<h4 style="text-align: center;">
					触圈财务管理系统</h4>
			</div>
			<!-- <share></share> -->
			<el-form-item prop="username">
				<el-input name="username" type="text" v-model="loginForm.username" autoComplete="off"
					placeholder="请输入手机号" />
			</el-form-item>
			<el-form-item>
				<el-input name="phoneCode" type="text" style="width: 55%;" v-model="loginForm.phoneCode"
					autoComplete="off" placeholder="请输入手机验证码" />
				<el-button class="btn-orange" type="info" style="width:30%;" :disabled="disabled"
					@click="getPhoneCode()">{{valiBtn}}</el-button>
			</el-form-item>
			
			<el-button class="loginBtn" type="primary" style="width:85%;margin-bottom:30px;" :loading="loading"
				@click="handleLogin">登录</el-button>
		</el-form>
	</div>
</template>

<script>
	import {
		getcode,
		userlogin,
		pwuserlogin
	} from '../api/user.js'
	import Cookie from 'js-cookie'
	import share from "../components/page/bshare.vue"
	export default {
		components:{
			share
		},
		name: 'login',
		data() {
			const validateUsername = (rule, value, callback) => {
				if (value.length < 11) {
					callback(new Error('请输入手机号'))
				} else {
					callback()
				}
			}
			return {
				imgsrc:'https://btt.ichuquan.com/image/paint/20231122/feaea3d721e2dc6ca0428e2f27615184.jpg',
				loginversion:2,
				loginway: 1,
				loginForm: {
					username: '',
					phoneCode: '',
					password: '',
					code: '',
					codekey: ''
				},
				loginRules: {
					username: [{
						required: true,
						trigger: 'blur',
						validator: validateUsername
					}]

				},
				passwordType: 'password',
				codeUrl: '',
				loading: false,
				showDialog: false,
				valiBtn: '获取手机验证码',
				disabled: false
			}
		},
		methods: {
			changeway() {
				this.loginway == 1 ? this.loginway = 2 : this.loginway = 1
			},
			changeimg(){
				this.loginversion == 1 ? this.loginversion = 2 : this.loginversion = 1
				this.imgsrc == 'https://chuoooo.com/_nuxt/img/logo.41e5199.png' ? this.imgsrc = 'https://bt.ichuquan.com/image/paint/20231122/feaea3d721e2dc6ca0428e2f27615184.jpg' : this.imgsrc = 'https://chuoooo.com/_nuxt/img/logo.41e5199.png'
			},
			handkeyCode(e) {
				if (e.keyCode === 13) {
					this.handleLogin()
				}
			},
			showPwd() {
				if (this.passwordType === 'password') {
					this.passwordType = ''
				} else {
					this.passwordType = 'password'
				}
			},
			getCode() {
				codeImg().then(res => {
					this.codeUrl = 'data:image/png;base64,' + res.data.data.image
					this.loginForm.codekey = res.data.data.key
				})
			},
			handleLogin() {
				if (this.loginForm.username !== '') {
					if (this.loginForm.phoneCode !== '') {
						this.loading = true
						if (this.loginway == 1) {
							//手机验证码
							userlogin({
								tel: this.loginForm.username,
								code: this.loginForm.phoneCode,
								loginversion:this.loginversion
							}).then(res => {
								if (res.code == 1) {
									this.$message({
										message: '登录成功',
										type: 'success'
									});
									//获取菜单数据
									this.$store.commit('setmenu', res.menu)
									//动态注册路由
									this.$store.commit('addmenu', this.$router)
									Cookie.set('token', res.token)

									this.loginForm.username = ''
									this.loginForm.phoneCode = ''
									this.$router.push('/home')
								} else {
									this.$message({
										message: res.msg,
										type: 'error'
									});
									this.loginForm.username = ''
									this.loginForm.phoneCode = ''
									this.$router.push('/login')
								}
								this.loading = false
								//console.log(res);
							})
						} else {
							//账号密码
							pwuserlogin({
								tel: this.loginForm.username,
								code: this.loginForm.phoneCode,
								loginversion:this.loginversion
							}).then(res => {
								if (res.code == 1) {
									this.$message({
										message: '登录成功',
										type: 'success'
									});
									//获取菜单数据
									this.$store.commit('setmenu', res.menu)
									//动态注册路由
									this.$store.commit('addmenu', this.$router)
									Cookie.set('token', res.token)

									this.loginForm.username = ''
									this.loginForm.phoneCode = ''
									this.$router.push('/home')
								} else {
									this.$message({
										message: res.msg,
										type: 'error'
									});
									this.loginForm.username = ''
									this.loginForm.phoneCode = ''
									this.$router.push('/login')
								}
								this.loading = false
							})
						}

					} else {
						this.$message.error('验证码不能为空');
					}
				} else {
					this.$message.error('手机不能为空');
				}
			},

			getPhoneCode() {

				if (this.loginForm.username !== '') {
					getcode({
						tel: this.loginForm.username
					}).then(res => {
						console.log(res);
						if (res.id == '1') {
							this.$message.success('手机验证码获取成功')
							this.valiBtn = '获取验证码'
							this.disabled = false
						} else {
							this.$message.error('手机验证码获取失败')
						}
					})
				} else {
					this.$message.error('手机不能为空');
					//window.location.reload()
				}
				this.tackBtn()
			},
			tackBtn() { // 验证码倒数60秒
				let time = 60
				let timer = setInterval(() => {
					if (time === 0) {
						clearInterval(timer)
						this.valiBtn = '获取验证码'
						this.disabled = false
					} else {
						this.disabled = true
						this.valiBtn = time + '秒后重试'
						time--
					}
				}, 1000)
			}
		},
		created() {
			window.addEventListener('keydown', this.handkeyCode, true) //开启监听键盘按
		},
		destroyed() {
			// window.removeEventListener('hashchange', this.afterQRScan)
		}
	}
</script>

<style lang="less" scoped>
	/* reset element-ui css */
	.login-container {
		.el-input {
			display: inline-block;
			height: 47px;
			width: 85%;

			input {
				background: transparent;
				border: 0px;
				-webkit-appearance: none;
				border-radius: 0px;
				padding: 12px 5px 12px 15px;
				color: #eee;
				height: 47px;

				&:-webkit-autofill {
					-webkit-box-shadow: 0 0 0px 1000px #2d3a4b inset !important;
					-webkit-text-fill-color: #fff !important;
				}
			}
		}

		.el-form-item {
			border: 1px solid rgba(255, 255, 255, 0.1);
			background: rgba(255, 255, 255, 0.7);
			border-radius: 5px;
			color: #454545;
		}
	}


	.login-container {
		position: fixed;
		height: 100%;
		width: 100%;

		/*background: url(./../assets/login.jpg) 50% 50% no-repeat;*/
		.login-form {
			position: absolute;
			top: 40%;
			left: 0;
			right: 0;
			width: 520px;
			min-height: 400px;
			padding: 35px 35px 15px 35px;
			margin: -260px auto 0;
		}

		.tips {
			font-size: 14px;
			color: #fff;
			margin-bottom: 10px;

			span {
				&:first-of-type {
					margin-right: 16px;
				}
			}
		}

		.svg-container {
			padding: 6px 5px 6px 15px;
			color: #889aa4;
			vertical-align: middle;
			width: 30px;
			display: inline-block;

			&_login {
				font-size: 20px;
			}
		}

		.title-container {
			position: relative;
			right: 9%;

			.title {
				font-size: 26px;
				font-weight: 400;
				color: #eee;
				margin: 0px auto 40px auto;
				text-align: center;
				font-weight: bold;
			}

			.set-language {
				color: #fff;
				position: absolute;
				top: 5px;
				right: 0px;
			}
		}

		.show-pwd {
			position: absolute;
			right: 10px;
			top: 7px;
			font-size: 16px;
			color: #889aa4;
			cursor: pointer;
			user-select: none;
		}

		.thirdparty-button {
			position: absolute;
			right: 35px;
			bottom: 28px;
		}
	}

	.loginBtn {
		background: #407ffe;
		height: 64px;
		line-height: 32px;
		font-size: 24px;
	}

	.el-form-item {
		margin-bottom: 20px;
	}

	.regInfo {
		text-align: center;
		color: #fff;
		font-size: 16px;
	}
</style>
